export const getPartialRolloutRoute = () => `partialRollout`;
export const getMultiplePartialRolloutRoute = (path) =>
  `bulkPartialRollout/${path}`;
export const postPincode = () =>
  'bulkPartialRollout/enablePincodesForDiscoveryApp';
export const getPincodes = () =>
  `bulkPartialRollout/partialRolloutsEnabledPincodes`;
export const getAllSchool = () => `bcc/school/all`;
export const postStatusFeaturedSchool = () => `bcc/school/featured`;
